import superjson from 'superjson';
import { z } from 'zod';

export const schema = z.object({
  sessionId: z.string().min(1),
  todoId: z.string().min(1),
  candidateId: z.string().min(1),
});
export type InputType = z.infer<typeof schema>;

export const executeCandidate = async (body: InputType, init?: RequestInit) => {
  const validated = schema.parse(body);
  const res = await fetch('/_api/todos/execute-candidate', {
    method: 'POST',
    credentials: 'include',
    body: superjson.stringify(validated),
    headers: { 'Content-Type': 'application/json' },
    ...init,
  });
  if (!res.ok) {
    const err = superjson.parse(await res.text());
    throw new Error(err.error || 'Execute candidate error');
  }
  return superjson.parse(await res.text());
};
